import { render, staticRenderFns } from "./HeadBanner.vue?vue&type=template&id=54552bf7"
import script from "./HeadBanner.vue?vue&type=script&lang=js"
export * from "./HeadBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports